import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Alert } from '@bringg/react-components';
import { observer } from 'mobx-react-lite';

import useStores from '../../../recipes/use-stores';
import AllowedEmailDomainsView from './allowed-email-domains';

import styles from './allowed-email-domains.module.scss';

const AllowedEmailDomainsContainer: React.FC = observer(() => {
	const { t } = useTranslation();
	const { driversStore } = useStores();

	const [loadingUsers, setLoadingUsers] = useState(true);
	const [usersLoadError, setUsersLoadError] = useState(false);

	useEffect(() => {
		const loadAdmins = async () => {
			try {
				await driversStore.loadAdminsAndDispatchers({ limit: 1000 });
			} catch (error) {
				console.error('Failed to load admins and dispatchers', error);
				setUsersLoadError(true);
			} finally {
				setLoadingUsers(false);
			}
		};
		void loadAdmins();
	}, [driversStore]);

	if (usersLoadError) {
		return (
			<div className={styles.allowedEmailDomains} data-test-id="allowed-email-domains">
				<Alert
					type="warning"
					message={t('SECURITY.ALLOWED_EMAIL_DOMAINS.USERS_LOAD_ERROR')}
					showIcon
					data-test-id="users-load-error-banner"
				/>
			</div>
		);
	}

	if (loadingUsers) {
		return null;
	}

	return <AllowedEmailDomainsView />;
});

export default AllowedEmailDomainsContainer;
